var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 21,
    viewBox: "0 0 28 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 14H11.2C11.5713 14 11.9274 13.8525 12.1899 13.5899C12.4525 13.3274 12.6 12.9713 12.6 12.6C12.6 12.2287 12.4525 11.8726 12.1899 11.6101C11.9274 11.3475 11.5713 11.2 11.2 11.2H7C6.6287 11.2 6.2726 11.3475 6.01005 11.6101C5.7475 11.8726 5.6 12.2287 5.6 12.6C5.6 12.9713 5.7475 13.3274 6.01005 13.5899C6.2726 13.8525 6.6287 14 7 14ZM23.8 0H4.2C3.08609 0 2.0178 0.442499 1.23015 1.23015C0.442499 2.0178 0 3.08609 0 4.2V16.8C0 17.9139 0.442499 18.9822 1.23015 19.7698C2.0178 20.5575 3.08609 21 4.2 21H23.8C24.9139 21 25.9822 20.5575 26.7698 19.7698C27.5575 18.9822 28 17.9139 28 16.8V4.2C28 3.08609 27.5575 2.0178 26.7698 1.23015C25.9822 0.442499 24.9139 0 23.8 0ZM25.2 16.8C25.2 17.1713 25.0525 17.5274 24.7899 17.7899C24.5274 18.0525 24.1713 18.2 23.8 18.2H4.2C3.8287 18.2 3.4726 18.0525 3.21005 17.7899C2.9475 17.5274 2.8 17.1713 2.8 16.8V8.4H25.2V16.8ZM25.2 5.6H2.8V4.2C2.8 3.8287 2.9475 3.4726 3.21005 3.21005C3.4726 2.9475 3.8287 2.8 4.2 2.8H23.8C24.1713 2.8 24.5274 2.9475 24.7899 3.21005C25.0525 3.4726 25.2 3.8287 25.2 4.2V5.6Z",
    fill: "#252525"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletOutline);
export default __webpack_public_path__ + "static/media/wallet-outline.0b43ff45470a34d3862d6170db6fb27a.svg";
export { ForwardRef as ReactComponent };